import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber'
})
export class ToNumberPipe implements PipeTransform {
  transform(value: string): any {
    if (value && typeof value == 'string') {
      value = value.replace(/\s+/g, '').replace(',', '.');
    }
    let retNumber = Number(value);
    return isNaN(retNumber) || retNumber == 0 ? null : retNumber;
  }
}
